import { render, staticRenderFns } from "./AgentTaskModal.vue?vue&type=template&id=52c8b5a0&scoped=true"
import script from "./AgentTaskModal.vue?vue&type=script&lang=js"
export * from "./AgentTaskModal.vue?vue&type=script&lang=js"
import style0 from "./AgentTaskModal.vue?vue&type=style&index=0&id=52c8b5a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c8b5a0",
  null
  
)

export default component.exports